import React from "react"
import * as classNames from "./TagsListSection.module.scss"
import Section from "../../../../core/layout/main/section/Section"
import Button from "../../../common/blocks/button/Button"
import { tagUrl } from "../../../../../utils/routeLib"
function TagsListSection({ tags, title }) {

  return (
    <Section
      container={"fluid"}
      className={classNames.tagList}
    >
      <h2>{title}</h2>
      <div className={classNames.tags}>
        {tags?.data?.map((tag, i) => (
          <div>
            <Button
              key={tag}
              aspect="tag"
              to={tagUrl(tag.attributes.autoRoute)}
              color="secondary"
            >
              #{tag.attributes.label}
            </Button>
          </div>
        ))}
      </div>
    </Section>
  )
}
export const name = "TagsListSection"

export const init = (componentData, pageContext) => {
  return (
    <TagsListSection
      key={componentData.id}
      title={componentData.label}
      tags={componentData.tags}
    />
  )
}

export default TagsListSection
